// extracted by css-extract-rspack-plugin
export default {"add-tracking":"addTracking_add-tracking__XQxrE","addTracking":"addTracking_add-tracking__XQxrE"};